import { GeneralInfoComponent } from './GeneralInfo';
import { connect } from 'react-redux';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state: any) => ({
  stepsStore: state.quotationState
});

export const GeneralInfo = connect(mapStateToProps)(GeneralInfoComponent);
